import styled from 'styled-components';

import { media } from '@theme/mixins';
import colors from '@theme/colors';

export const FieldInput = styled.div`
  font-family: GTAmerica;
  width: 100%;
  height: 64px;
  appearance: none;
  font-size: 14px;
  letter-spacing: 0.5px;
  box-shadow: none;
  border-radius: 0px;
  padding: 22px 25px;
  color: ${({ dark }) => (dark ? colors['charcoal'] : colors['charcoal'])};
  background-color: ${colors['white']};
  border: ${({ error }) =>
    error ? `solid 2px ${colors['error-red']}` : 'none'};

  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${colors['charcoal']};
    opacity: 0.54;
  }
  &::-ms-clear {
    width: 0;
    height: 0;
  }

  ${media.tabletPortraitUp`
    font-size: 17.5px;
  `};
`;
